import { Link } from 'react-router-dom';

const VARIANTS = {
  light: {
    nav: 'flex flex-wrap items-center gap-x-2 gap-y-1 text-sm text-[#666666]',
    link: 'font-medium text-[#9369CC] transition hover:underline',
    current: 'font-medium text-[#1B1B1B]',
    muted: 'text-[#666666]',
    separator: 'text-[#AAAAAA]',
  },
  page: {
    nav: 'flex flex-wrap items-center gap-x-2 gap-y-1 text-sm font-medium text-[#1B1B1B] sm:text-base',
    link: 'text-[#1B1B1B] transition hover:text-[#9369CC]',
    current: 'text-[#1B1B1B]',
    muted: 'text-[#1B1B1B]',
    separator: 'text-[#1B1B1B]',
  },
  dark: {
    nav: 'flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-white/55 sm:text-sm',
    link: 'transition hover:text-white/90',
    current: 'text-white/85',
    muted: 'text-white/55',
    separator: 'text-white/35',
  },
};

function Breadcrumbs({ items = [], variant = 'light', className = '' }) {
  const styles = VARIANTS[variant] || VARIANTS.light;

  if (!items.length) return null;

  return (
    <nav className={`${styles.nav} ${className}`.trim()} aria-label="Breadcrumb">
      {items.map((crumb, index) => {
        const isLast = index === items.length - 1;

        return (
          <span key={`${crumb.label}-${index}`} className="flex items-center gap-2">
            {index > 0 ? (
              <span className={styles.separator} aria-hidden>
                {variant === 'page' ? (
                  <svg className="h-2.5 w-2.5 fill-current" viewBox="0 0 8 12">
                    <path d="M0 0L8 6L0 12V0Z" />
                  </svg>
                ) : (
                  '>'
                )}
              </span>
            ) : null}
            {crumb.path && !isLast ? (
              <Link to={crumb.path} state={crumb.state} className={styles.link}>
                {crumb.label}
              </Link>
            ) : (
              <span className={isLast ? styles.current : styles.muted}>{crumb.label}</span>
            )}
          </span>
        );
      })}
    </nav>
  );
}

export default Breadcrumbs;
